<template>
  <div id="faq">
    <div class="head">
      <div class="head-left">
        <router-link to="/">
          <img class="logo" src="@/assets/logo.png">
        </router-link>
      </div>

      <div class="head-right">

        <div class="head-right-item">

          <router-link :to="{name: 'Home',path:'/home'}" :class="{active:hshow==1}" hshow="1" @click="hchange">产品介绍</router-link>
          <div class="underline"></div>

        </div>
        <div class="head-right-item" :class="{active:hshow==2}" hshow="2" @click="hchange">
          <router-link :to="{name: 'Tryout',path:'/tryout'}" :class="{active:hshow==2}" hshow="2" @click="hchange">产品试用</router-link>
          <div class="underline"></div>

        </div>
        <div class="head-right-item" :class="{active:hshow==3}" hshow="3" @click="hchange">
          <router-link :to="{name: 'Purchase',path:'/purchase'}" :class="{active:hshow==3}" hshow="3" @click="hchange">产品采购</router-link>
          <div class="underline"></div>

        </div>
        <div class="head-right-item" :class="{active:hshow==4}" hshow="4" @click="hchange">
          <router-link :to="{name: 'FAQ',path:'/faq'}" :class="{active:hshow==4}" hshow="4" @click="hchange">FAQ</router-link>
          <div class="underline"></div>
        </div>

      </div>
    </div>

    <div class="main">

      <div class="main-left">
        <div class="main-left-item">
          <div class="circular">
          </div>
          <div class="main-left-item-content" :class="{active:show==1}" show="1" url="http://diybt.powerlbs.com/4.1.htm"   @click="changeIframeUrl">
            集成类
          </div>
        </div>
        <div class="main-left-item">
          <div class="circular">

          </div>
          <div class="main-left-item-content" :class="{active:show==2}" show="2" url="http://diybt.powerlbs.com/4.2.htm"   @click="changeIframeUrl">
            质量类
          </div>
        </div>
        <div class="main-left-item">
          <div class="circular">

          </div>
          <div class="main-left-item-content" :class="{active:show==3}" show="3" url="http://diybt.powerlbs.com/4.3.htm"   @click="changeIframeUrl">
            咨询类
          </div>
        </div>
        <div class="main-left-item">
          <div class="circular">

          </div>
          <div class="main-left-item-content" :class="{active:show==4}" show="4" url="http://diybt.powerlbs.com/4.4.htm"   @click="changeIframeUrl">
            费用类
          </div>
        </div>

        <div class="main-left-item">
          <div class="circular">

          </div>
          <div class="main-left-item-content" :class="{active:show==5}" show="5" url="http://diybt.powerlbs.com/4.5.htm"   @click="changeIframeUrl">
            定位技术
          </div>
        </div>

      </div>
      <div class="main-right">
        <div class="icon-left-top">

          <img src="@/assets/icon-left-top.png">

        </div>
        <div class="content">
          <iframe :src=iframeUrl frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="yes"
                  allowtransparency="yes"></iframe>
        </div>

        <div class="icon-right-bottom"></div>
        <div class="icon-right-bottom2"></div>
      </div>

    </div>

    <div class="foot">

      <div class="foot-content">
        中科劲点(北京)科技有限公司 版权所有

      </div>

      <div class="foot-content">
      地址:北京市海淀区中关村创业大街昊海楼2层   联系方式：137 1787 2355
      </div>
      <div class="foot-content">
        京ICP备15047372号-1 京公网安备 11010802033207
      </div>

    </div>
  </div>
</template>
<script>

export default {
  name: "faq",
  data: () => {
    return {
      iframeUrl: "http://diybt.powerlbs.com/4.1.htm",
      show: 1,
      hshow: 4
    }
  },
  mounted() {


  },
  methods: {
    changeIframeUrl: function (event) {
      this.iframeUrl = event.target.getAttribute("url")
      this.show = event.target.getAttribute("show")
    },
    hchange: function (event) {
      this.hshow = event.target.getAttribute("hshow");
    }
  }
}

</script>

<style scoped lang="scss">

.active {
  color: #ff6500;
  display: block;
}

.head {
  display: flex;
  width: 100vw;
  height: 4.219vw;
  background-color: #393939;
  box-shadow: 0vw 0.26vw 0.583vw 0.25vw rgba(57, 57, 57, 0.27);
  align-items: center;
}


.head-left {
  width: 12.396vw;
  height: 2.604vw;
  margin-left: 2.865vw;

}

.head-right {
  display: flex;
  margin-left: 50.594vw;
}

.head-left .logo {
  width: 10.396vw;
  margin-top: 0.5vw;
}

.head-right-item {
  font-family: PingFang-SC-Bold;
  font-size: 1vw;
  line-height: 4.557vw;
  letter-spacing: 0.042vw;
  color: #ffffff;

}

.head-right-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 3.146vw;
}

.head-right-item :hover {
  color: #ff6500;
}

.underline {
  width: 2.188vw;
  height: 0.217vw;
  background-color: #ff6500;
  margin-top: -0.653vw;
  display: none;
}


.head-right-item:hover .underline {
  display: block;
}

.main {
  display: flex;
  height: 62.396vw;
  width: 100vw;
}

.main-left {
  width: 22vw;
  height: 62.396vw;
  background-color: #f9f9fc;
  padding-top: 4.583vw;
  padding-left: 2.656vw;
}

.main-left-item {
  width: 12vw;
  font-family: PingFang-SC-Medium;
  font-size: 0.9vw;
  color: #586376;
  display: flex;
  align-items: center;
  margin-bottom: 1.12vw;
  cursor: pointer;
}


.main-left-item:hover {
  color: #ff6500;
}

.main-left-item:hover .circular {
  display: block;
  margin-left: -0.3605vw;
}

.circular {
  width: 0.521vw;
  height: 0.521vw;
  background-image: linear-gradient(90deg, #ff6500 0%, #ff9d33 100%),
  linear-gradient(#586376, #586376);
  border-radius: 50%;
  display: none;
}

.main-left-item-content {
  margin-left: 0.4vw;
}


.icon-right-bottom {

  width: 5.052vw;
  height: 5.052vw;
  background-image: linear-gradient(90deg,
      #fe630e 0%,
      #f9c24c 100%),
  linear-gradient(
          #586376,
          #586376);
  background-blend-mode: normal,
  normal;

  border-radius: 50%;
}

.icon-right-bottom2 {
  width: 4.792vw;
  height: 4.792vw;
  background-image: linear-gradient(90deg,
      #ff9d33 0%,
      #fdff33 100%),
  linear-gradient(
          #586376,
          #586376);
  background-blend-mode: normal,
  normal;
  opacity: 0.6;

  border-radius: 50%;
}

.main-right {
  position: relative;
  height: 62.396vw;

}


.main-right .content {
  width: 68.021vw;
  height: 52.135vw;
  background-color: #ffffff;
  box-shadow: 0vw 0.469vw 2.813vw 0vw rgba(255, 157, 51, 0.28);
  border-radius: 0.521vw;
  margin-left: 5.885vw;
  margin-top: 4.063vw;
}

.main-right .icon-left-top {
  position: absolute;
  top: 1vw;
  left: 4vw;

}

.main-right .icon-right-bottom {
  position: absolute;
  bottom: 5vw;
  right: -1vw;
  z-index: 999;
  opacity: 0.8;
}

.main-right .icon-right-bottom2 {
  position: absolute;
  bottom: 8vw;
  right: -2vw;
  z-index: 998;
  opacity: 0.6;
}

.foot {
  width: 100vw;
  height: 7.24vw;
  background-color: #393939;
  font-family: PingFang-SC-Medium;
  font-size: 0.8vw;

  line-height: 2.188vw;
  letter-spacing: 0.052vw;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

iframe {
  width: 100%;
  height: 100%;
}


</style>
